module.exports = __webpack_public_path__ + "img/lipigo1.31716fa7.jpg";